// src/components/Report/shared/StatCard.jsx
import React from "react";
import { motion } from "framer-motion";
import { pal, hex2rgba } from "./reportUtils";
import ScoreRing from "./scoring";

function formatScore(score) {
  if (score == null) return "";
  return Number.isInteger(score) ? score : score.toFixed(1);
}

/**
 * Clickable subject summary card with an animated score ring.
 * Used for the row of subject cards at the top of each report page.
 */
export default function StatCard({ subject, score, attempts, active, onClick }) {
  const p = pal(subject);
  const label = subject.length > 14 ? subject.slice(0, 14) + "…" : subject;
  const displayScore = formatScore(score);

  return (
    <motion.button
      onClick={onClick}
      whileHover={{ y: -3 }}
      whileTap={{ scale: 0.97 }}
      className={`dlg-stat-card${active ? " dlg-stat-card--active" : ""}`}
      style={{
        background: active ? p.solid : undefined,
        border: `1.5px solid ${active ? p.solid : "#e2e8f0"}`,
        boxShadow: active ? `0 8px 24px ${hex2rgba(p.solid, 0.28)}` : undefined,
      }}
    >
      <ScoreRing score={displayScore} color={active ? "#fff" : p.solid} size={48} strokeWidth={5} />
      <div>
        <div className={`dlg-stat-card-label dlg-stat-card-label--${active ? "active" : "inactive"}`}>
          {label}
        </div>
        <div className={`dlg-stat-card-score dlg-stat-card-score--${active ? "active" : "inactive"}`}>
          {displayScore}%
        </div>
        <div className={`dlg-stat-card-attempts dlg-stat-card-attempts--${active ? "active" : "inactive"}`}>
          {attempts} attempt{attempts !== 1 ? "s" : ""}
        </div>
      </div>
    </motion.button>
  );
}